import { css } from "@emotion/react";
import bgSupport from "assets/common/bgSupport.png";
import { theme } from "styles/theme";

export const HeaderStyle = {
  button: () => css`
    text-transform: uppercase;
    color: white;
    font-size: 14px;
    font-weight: 700;
    border-radius: 17px;
    background: linear-gradient(to top, #ff5d08, #ff955e);
    border-color: transparent;
    width: 130px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.25s;
    transition: all 0.3s ease;
    border: 0;
    &:focus-visible {
      outline: 4px solid ${theme.colors.orange[100]} !important;
    }

    :hover {
      color: white !important;
      border-color: transparent !important;
      background: linear-gradient(
        to top,
        ${theme.colors.gradient[100]},
        ${theme.colors.gradient[50]}
      );
      transition: 0.25s;
    }
  `,

  support: () => css`
    position: absolute;
    right: 0;
    width: 141px;
    height: 30px;
    line-height: 30px;
    color: #f00;
    font-size: 14px;
    text-align: center;
    background: url(${bgSupport});
    animation: loopSupport 6s infinite;

    @keyframes loopSupport {
      0% {
        opacity: 0;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
    }
  `,

  iconRefresh: () => css`
    width: 14px;
    height: 14px;
    vertical-align: middle;
    margin: 0 0 3px 10px;
    cursor: pointer;
    fill: #ff5d08;
    transform: rotate(0);
    &[data-loading=${"loading"}] {
      animation: spin 1s linear infinite;
    }

    @keyframes spin {
      from {
        transform: rotate(0);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `,
};
